import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { ENotice, ESnapshotExists } from 'lib/types';
import { PublicationIssueModel } from 'lib/model/objects/publicationIssueModel';
import { ColumnService } from 'lib/services/directory';
import { Alert } from 'lib/components/Alert';
import useAsyncEffect from 'lib/frontend/hooks/useAsyncEffect';
import { NoticesOverviewTable } from './NoticesOverviewTable';

type NoticesTabProps = {
  publicationIssue: PublicationIssueModel;
};

export function NoticesTab(props: NoticesTabProps) {
  const { publicationIssue } = props;

  const {
    value: notices,
    isLoading,
    isError,
    invalidateData
  } = useAsyncEffect<ESnapshotExists<ENotice>[]>({
    fetchData: () => publicationIssue.slowGetNoticesForPublicationIssue(),
    dependencies: [publicationIssue.id],
    initialData: [],
    errorConfig: {
      service: ColumnService.PAGINATION,
      message: 'Error getting notices for publication issue'
    }
  });

  return (
    <div className="space-y-3">
      {isError && (
        <Alert
          id="notices-error-alert"
          status="error"
          title="Error Loading Notices"
          description="There was a problem loading notices for this publication issue. Please try again."
          icon={<ExclamationTriangleIcon className="h-5 w-5" />}
        >
          <button
            onClick={invalidateData}
            className="mt-2 underline text-sm hover:no-underline"
          >
            Try again
          </button>
        </Alert>
      )}
      <NoticesOverviewTable notices={notices || []} loading={isLoading} />
    </div>
  );
}
